import React from "react"
import {Field} from "react-final-form";
import TextFieldWrapper from "../../Form/TextField";
import {useTranslation} from "react-i18next";

const FirstNameField = () => {
    const { t } = useTranslation()

    const validate = {
        firstName: (item: string | null) => {
            if (item) return item.length < 2 ? t('errors.firstName') : ''
            return t('errors.required')
        },
    }

    return (
        <Field
            name="firstName"
            type="text"
            validate={validate.firstName}
        >
            {(props) => (
                <TextFieldWrapper
                    {...props}
                    fullWidth
                    variant="outlined"
                    required
                    placeholder={t('common.firstName')}
                />
            )}
        </Field>
    )
}

export default FirstNameField
